import { Card } from "antd";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import styled, { keyframes } from "styled-components";

export const LoadingContainer = styled.div`
  position: absolute;
  z-index: 999999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
`;

export const StyledCard = styled(Card)`
  width: 400px;
  height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
`;

const spin = keyframes`
  to {
    transform: rotate(360deg);
  }
`;

export const CustomIcon = styled(AiOutlineLoading3Quarters)`
  animation: ${spin} 1s linear infinite;
`;
